import { render, staticRenderFns } from "./PendingTasks.vue?vue&type=template&id=2bb3a97c&scoped=true"
import script from "./PendingTasks.vue?vue&type=script&lang=js"
export * from "./PendingTasks.vue?vue&type=script&lang=js"
import style0 from "./PendingTasks.vue?vue&type=style&index=0&id=2bb3a97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb3a97c",
  null
  
)

export default component.exports